import { Inject, Injectable, Optional } from '@angular/core';
import { environment } from 'environments/environment';
import { User, UserService } from '@adeo/ngx-kozikaza-api';
import { CookieService } from 'ngx-cookie';

@Injectable({
  providedIn: 'root',
})
export class KzpService {
  constructor(
    @Optional() @Inject('DEFAULT_COUNTRY') private readonly country,
    private cookieService: CookieService,
    private userService: UserService,
  ) {
  }

  private getPartnerKeyFromCountryCode(countryCode): string {
    const pk = (environment.KAZAPLAN_KEYS.find((o) => o.countryCode === countryCode)?.partnerKey)
      || (environment.KAZAPLAN_KEYS.find((o) => o.countryCode === 'FR')?.partnerKey);
    return pk;
  }

  public getPartnerKeyFromUser(user: User): string {
    if (user.partnerKey) {
      this.cookieService.put(environment.COOKIE_KAZAPLAN_KEY_NAME, `${user.partnerKey}`);
      return user.partnerKey;
    } else {
      const defaultCountry = this.country || 'FR';
      const partnerKey = this.getPartnerKeyFromCountryCode(defaultCountry);
      this.cookieService.put(environment.COOKIE_KAZAPLAN_KEY_NAME, `${partnerKey}`);
      this.userService.putUser({'@id': user['@id'], partnerKey}).subscribe();
      return partnerKey;
    }
  }

  public getPartnerKeyFromCookie(updateUser = false, user?: User): string {
    let partnerKey = this.cookieService.get(environment.COOKIE_KAZAPLAN_KEY_NAME);
    if (partnerKey === null || partnerKey === undefined || partnerKey === 'undefined') {
      const defaultCountry = this.country || 'FR';
      partnerKey = this.getPartnerKeyFromCountryCode(defaultCountry);
      this.cookieService.put(environment.COOKIE_KAZAPLAN_KEY_NAME, `${partnerKey}`);
    }
    if (updateUser && user && user['@id']) {
      this.userService.putUser({'@id': user['@id'], partnerKey}).subscribe();
    }
    return partnerKey;
  }

  public getAppIdFromPartnerKey(partnerKey: string): string {
    const appId = environment.KAZAPLAN_KEYS.find((o) => o.partnerKey === partnerKey)?.appId;
    return appId;
  }

}
